import { createSelector, createSlice } from '@reduxjs/toolkit';

import { RootState } from '$store/rootReducer';
import {
  BundlesState,
  SetFormNameAction,
  SetFormPriceAction,
  SetFormDescriptionAction,
  SetBundlesAction,
  SetBundleAction,
  SetFormIdAction,
  SetDecryptKeyAction,
  EditBundleAction,
  GetBundleAction,
  DeleteBundleAction,
  SetFailedAction,
} from './interface';
import { BundleModel } from '$store/models';

const initialState: BundlesState = {
  bundles: {},
  decryptKeys: {},
  failed: null,
  form: {
    id: 0,
    price: '',
    priceWithoutDiscount: '',
    name: '',
    description: '',
  },
};

export const { actions, reducer } = createSlice({
  name: 'bundles',
  initialState,
  reducers: {
    setFailed(state, action: SetFailedAction) {
      state.failed = action.payload;
    },
    getBundle(_, action: GetBundleAction) {},
    deleteBundle(_, action: DeleteBundleAction) {},
    editBundle(_, action: EditBundleAction) {},
    clearForm: (state) => {
      state.form = initialState.form;
    },
    setDecryptKey: (state, action: SetDecryptKeyAction) => {
      const { bundleId, decryptKey } = action.payload;
      state.decryptKeys[bundleId] = decryptKey;
    },
    setBundles: (state, action: SetBundlesAction) => {
      action.payload.forEach((bundle) => {
        state.bundles[bundle.id] = {
          ...state.bundles[bundle.id],
          ...bundle,
          content: bundle.content || state.bundles[bundle.id]?.content,
          previews: bundle.previews || state.bundles[bundle.id]?.previews,
        };
      });
    },
    setBundle: (state, action: SetBundleAction) => {
      const bundle = state.bundles[action.payload.id];
      if (bundle) {
        state.bundles[bundle.id] = {
          ...bundle,
          ...action.payload,
          content: action.payload.content || bundle.content,
          previews: action.payload.previews || bundle.previews,
        };
      } else {
        state.bundles[action.payload.id] = action.payload;
      }
    },
    setFromId: (state, action: SetFormIdAction) => {
      state.form.id = action.payload;
    },
    setFromPrice: (state, action: SetFormPriceAction) => {
      state.form.price = action.payload;
    },
    setFromPriceWithoutDiscount: (state, action: SetFormPriceAction) => {
      state.form.priceWithoutDiscount = action.payload;
    },
    setFromName: (state, action: SetFormNameAction) => {
      state.form.name = action.payload;
    },
    setFromDescription: (state, action: SetFormDescriptionAction) => {
      state.form.description = action.payload;
    },
    createBundle() {},
    saveBundle() {},
  },
});

export { reducer as bundlesReducer, actions as bundlesActions };
export const bundlesSelector = (state: RootState) => state.bundles;
export const bundlesFormSelector = (state: RootState) => state.bundles.form;
export const bundlesFailedSelector = (state: RootState) => state.bundles.failed;

export const bundleSelector = createSelector(
  [bundlesSelector, (_, bundleId: number) => bundleId],
  (state, bundleId) => state.bundles[bundleId] as BundleModel,
);

export const bundleDecryptKeySelector = createSelector(
  [bundlesSelector, (_, bundleId: number) => bundleId],
  (state, bundleId) => state.decryptKeys[bundleId],
);
